import { render, staticRenderFns } from "./lunwenDetail-page.html?vue&type=template&id=3eb08ce9&"
import script from "./lunwenDetail-page.ts?vue&type=script&lang=ts&"
export * from "./lunwenDetail-page.ts?vue&type=script&lang=ts&"
import style0 from "./lunwenDetail-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports